import { useQuery } from '@tanstack/react-query'
import type { FeatureToggleResponseDto } from '@trellis/api'
import type { FeatureKey } from '@trellis/shared'

import { getFeatureFlags } from '@/requests'

export function useFeatureFlags() {
  return useQuery({
    queryKey: ['feature-flags'],
    queryFn: getFeatureFlags,
    select: (result) => result.data ?? [],
    staleTime: 5 * 60 * 1000, // 5 min — feature toggles rarely change mid-session
  })
}

/** Check if a feature is enabled within a pre-fetched toggles array. */
export function isFeatureEnabled(
  toggles: FeatureToggleResponseDto[] | undefined,
  key: FeatureKey,
): boolean {
  return toggles?.find((toggle) => toggle.key === key)?.enabled ?? false
}

/** Filters out items whose `feature` is set but disabled for the tenant. */
export function filterByFeature<T extends { feature?: FeatureKey }>(
  items: T[],
  toggles: FeatureToggleResponseDto[] | undefined,
): T[] {
  return items.filter((item) => !item.feature || isFeatureEnabled(toggles, item.feature))
}
